/*@ngInject*/
const UINumberWithCommasFormatterDirective = function ($timeout, $filter, submissionConstant) {

    let linkFunction = function ($scope, $elm, $attrs, ngModelController) {

        let isEnabled,
            numberFilter = $filter('number', 0),
            numberDomain,
            element = $($elm),
            timeoutList = [];

        function run() {

            function handleFocus() {
                let strLength,
                    viewValue;
                if (ngModelController.$modelValue) {
                    viewValue = ngModelController.$viewValue;
                    viewValue = _.replace(viewValue, /\,/gi, '');

                    ngModelController.$viewValue = viewValue;
                    ngModelController.$render();
                } else {
                    ngModelController.$viewValue = '';
                    ngModelController.$render();
                }
                strLength = ngModelController.$viewValue.length;
                $elm[0].setSelectionRange(strLength, strLength);
            }

            function handleBlur() {
                let value,
                    numberArray = [];
                if (!isNaN(ngModelController.$modelValue)) {
                    numberArray = _.split(ngModelController.$modelValue, '.');
                    if(numberArray.length === 1) {
                        value = parseFloat(ngModelController.$modelValue);
                        ngModelController.$viewValue = numberFilter(value);
                    } else {
                        value = parseFloat(numberArray[0]);
                        ngModelController.$viewValue = numberFilter(value, 0) + '.' + numberArray[1];
                    }

                    ngModelController.$render();
                }
            }

            function handleKeydown(event) {
                if (!isKeyAllowed(event)) {
                    return event.preventDefault();
                }
            }

            function isKeyAllowed(event) {
                let currentChar = event.keyCode || event.which;

                // allow TAB, ENTER, COMMA
                if (_.includes([9, 44, 13], currentChar)) {
                    return true;
                }

                return _.isNumber(_.parseInt(String.fromCharCode(currentChar)));
            }

            $scope.$watch($attrs.ngModel, function (newValue) {
                if (!element.is(':focus') && newValue) {
                    handleBlur();
                }
            });

            $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function () {
                if (!element.is(':focus')) {
                    handleBlur();
                } else {
                    handleFocus();
                }
            });

            element.on('focus', handleFocus);
            element.on('blur', handleBlur);
            element.on('keypress', handleKeydown);

            $scope.$on('$destroy', function () {
                element.off('focus', handleFocus);
                element.off('blur', handleBlur);
                element.off('keypress', handleKeydown);
            });
        }

        timeoutList.push($timeout(function () {
            isEnabled = $elm.hasClass('ui-number-with-commas-formatter');

            if (isEnabled) {
                numberDomain = $elm.attr('ui-number-domain');
                run();
            }

        }, 300));

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });

    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiNumberWithCommasFormatter', UINumberWithCommasFormatterDirective);
